import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarImposto from "./CadastrarImposto";

const EditarImposto = () => {
    const { id } = useParams();
    return <CadastrarImposto impostoId={id} />;
};

export default EditarImposto;
